import React, { useState, useEffect } from 'react';
import "./termsConditionsPage.scss";
import { Container, Navbar } from 'react-bootstrap';
import { Logo } from '../../assets/svgImages/svgImages';
import { Link, useSearchParams } from 'react-router-dom';
import { getAuthCredentials, setQuoteCookies } from '../../utils/auth-utils';
import { productDetailsClient } from '../../data/product-details';
import html2pdf from 'html2pdf.js';
import { toast } from 'react-toastify';

const TermsConditionsPage = () => {
  const [htmlContent, setHtmlContent] = useState<any>('');
  const [searchParams] = useSearchParams();
  const orderFromUrl = searchParams.get('order');
  const customerFromUrl = searchParams.get('customer');
  const tokenFromUrl = searchParams.get('token') || undefined;
  if (orderFromUrl) {
    setQuoteCookies(orderFromUrl);
  }
  const { quoteId: cookieQuoteId, userUuid } = getAuthCredentials();
  const quoteId = orderFromUrl ?? cookieQuoteId;
  const [data, setData] = useState<any>();
  const [quoteData, setQuoteData] = useState<any>(null);
  const storedData = localStorage.getItem('data');

  const fetchTermsConditions = (resolvedQuoteData?: any) => {
    const source = orderFromUrl ? resolvedQuoteData?.quote : data;
    const request = {
      retailerUuid: source?.retailerUuid,
      storeUuid: source?.storeUuid,
      quoteUuid: quoteId,
      customerUuid: orderFromUrl ? (customerFromUrl || resolvedQuoteData?.quote?.customerUuid) : userUuid,
      termsAndConditionsAccepted: false
    };
    productDetailsClient.getTermsConditions(request, tokenFromUrl)
      .then((response: any) => {
        setHtmlContent(response);
      })
      .catch((error: any) => {
        console.error("Error fetching terms and conditions:", error);
      });
  };

  useEffect(() => {
    if (storedData) {
      setData(JSON.parse(storedData));
    }
  }, [storedData]);

  useEffect(() => {
    if (orderFromUrl) {
      productDetailsClient.getProductDetailsList({ quoteUuid: orderFromUrl })
        .then((res: any) => {
          setQuoteData(res);
          fetchTermsConditions(res);
        })
        .catch((error: any) => {
          toast.error(error?.message);
        });
    }
  }, [orderFromUrl]);

  useEffect(() => {
    if (!orderFromUrl && data) {
      fetchTermsConditions();
    }
  }, [data]);

  const wrapHtmlContentWithHeaderFooter = (content: string) => {
    return `
      <div class="pdf-wrapper">
        <div class="pdf-header">
          <div class="tc-logo">
            <svg width="572" height="163" viewBox="0 0 572 163" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
              <g clipPath="url(#clip0_136_232)">
                <path d="M221.66 105.139H167.875C169.857 114.039 177.388 119.49 188.223 119.49C195.754 119.49 201.176 117.233 206.064 112.583L217.035 124.541C210.427 132.113 200.515 136.099 187.698 136.099C163.113 136.099 147.128 120.555 147.128 99.296C147.128 78.0372 163.385 62.4934 185.055 62.4934C206.725 62.4934 222.059 76.5811 222.059 99.56C222.059 101.153 221.796 103.409 221.66 105.139ZM167.612 93.044H202.633C201.176 84.0071 194.442 78.1646 185.191 78.1646C175.94 78.1646 169.069 83.8797 167.612 93.044Z" fill="black" />
                <path d="M308.485 94.1088V135.034H287.865V97.3031C287.865 85.7454 282.578 80.4307 273.463 80.4307C263.552 80.4307 256.419 86.5371 256.419 99.6965V135.034H235.799V63.5491H255.486V71.9216C261.035 65.8061 269.363 62.4844 279.012 62.4844C295.794 62.4844 308.485 72.313 308.485 94.1088Z" fill="black" />
                <path d="M372.979 131.576C368.752 134.634 362.542 136.09 356.197 136.09C339.415 136.09 329.63 127.453 329.63 110.444V81.0859H318.659V65.1418H329.63V47.7324H350.25V65.1418H367.955V81.0859H350.25V110.18C350.25 116.287 353.554 119.618 359.103 119.618C362.144 119.618 365.185 118.689 367.43 116.96L372.979 131.576Z" fill="black" />
                <path d="M382.094 42.0265C382.094 35.5196 387.244 30.4688 394.911 30.4688C402.578 30.4688 407.728 35.2556 407.728 41.626C407.728 48.5333 402.578 53.5842 394.911 53.5842C387.244 53.5842 382.094 48.5333 382.094 42.0265ZM384.601 63.5493H405.221V135.034H384.601V63.5493Z" fill="black" />
                <path d="M419.098 99.287C419.098 77.7642 435.617 62.4844 458.744 62.4844C473.68 62.4844 485.438 68.9913 490.598 80.6855L474.603 89.3219C470.774 82.542 465.09 79.4933 458.609 79.4933C448.172 79.4933 439.98 86.801 439.98 99.287C439.98 111.773 448.172 119.081 458.609 119.081C465.081 119.081 470.765 116.159 474.603 109.252L490.598 118.025C485.447 129.455 473.68 136.099 458.744 136.099C435.617 136.099 419.098 120.819 419.098 99.2961V99.287Z" fill="black" />
                <path d="M572.001 63.5491L539.885 139.411C533.015 156.684 523.239 161.862 510.412 161.862C503.144 161.862 495.214 159.469 490.589 155.356L498.12 140.604C501.288 143.397 505.651 145.117 509.752 145.117C515.436 145.117 518.604 142.597 521.383 136.217L521.646 135.553L490.851 63.54H512.132L532.082 112.037L552.168 63.54H571.992L572.001 63.5491Z" fill="black" />
                <path fillRule="evenodd" clipRule="evenodd" d="M22.3851 120.191H44.3085V41.4075H2.11816V106.44C2.11816 106.44 2.788 120.182 22.3851 120.182V120.191Z" fill="#00989E" />
                <path fillRule="evenodd" clipRule="evenodd" d="M95.8864 0.29126C95.8864 0.29126 123.277 3.02143 103.671 41.7534C85.1238 78.4013 71.9082 103.674 71.9082 103.674L111.636 109.753L132.238 75.7439C132.238 75.7439 141.743 64.341 134.365 51.4182C127.133 38.7411 110.586 10.766 110.586 10.766C110.586 10.766 105.454 1.0284 95.8864 0.29126Z" fill="#00989E" />
                <path d="M95.9299 0H44.3076L23.7148 20.7038L44.3076 41.4075H103.841C122.877 3.46731 96.5636 0.0728044 95.9299 0Z" fill="#4CB7BB" />
                <path d="M111.563 109.716L71.9254 103.646C68.9293 114.367 75.6638 123.922 75.6638 123.922L95.2881 161.398H136.492C136.492 161.398 126.209 140.658 111.563 109.707V109.716Z" fill="#4CB7BB" />
                <path fillRule="evenodd" clipRule="evenodd" d="M44.517 120.191H22.4759C2.87882 120.191 2.20898 106.449 2.20898 106.449C2.20898 160.516 42.7157 161.717 44.7523 161.744" fill="#4CB7BB" />
                <path fillRule="evenodd" clipRule="evenodd" d="M44.5078 120.191L65.0916 140.895L44.7522 161.735" fill="#4CB7BB" />
              </g>
              <defs>
                <filter id="filter0_d_136_232" x="0.608984" y="104.529" width="45.103" height="57.8549" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="-0.32" dy="-0.64" />
                  <feGaussianBlur stdDeviation="0.64" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_136_232" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_136_232" result="shape" />
                </filter>
                <clipPath id="clip0_136_232">
                  <rect width="572" height="163" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <h2>Terms and Conditions</h2>
        </div>
        <div class="pdf-content">
          ${content}
        </div>
        <div class="pdf-footer">
          <p>© 2025 Renticy Limited</p>
        </div>
      </div>
    `;
  };

  const handleDownload = () => {
    const element = document.createElement('div');
    element.innerHTML = wrapHtmlContentWithHeaderFooter(htmlContent);

    const opt = {
      filename: 'Renticy Terms and Conditions.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
    };

    html2pdf().from(element).set(opt).save().then(() => {
      document.body.removeChild(element);
    }).catch((error: any) => {
      console.error('Error generating PDF:', error);
    });
  };

  useEffect(() => {
    console.log("HTML Content state updated:", htmlContent);
  }, [htmlContent]);

  return (
    <div className='termsconditions-section'>
      <Navbar fixed="top" expand="lg">
        <Container>
          <div className='termsconditions-header'>
            <div className="tc-logo">
              <Logo />
            </div>
            <Link to="#" onClick={handleDownload}>Download PDF</Link>
          </div>
        </Container>
      </Navbar>
      <div className='termsconditions-content'>
        <Container>
          <div className="row">
            <div className="col-12">
              <div className='terms-conditions-section'>
                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div className='termsconditions-footer'>
        <Container>
          <div className="footer-content">
            <p>© 2025 Renticy Limited</p>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default TermsConditionsPage;
